import React, { useState, useRef, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  VerifyAdharOTPServices,
  SendMobileOTPServices,
} from "../../services/index";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setPatientDetails } from "../../redux/slices/abhaSlice";

const AdhaOtp = ({ setAdharOtp, sendOtpFunction }) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const dispatch = useDispatch();

  const [mobile, setMobile] = useState("");
  const [msg, setMsg] = useState("");
  const [timer, setTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const mobilemsg = useSelector((state) => state.user.msgAdharmobile);
  const maskedNumber = mobilemsg?.match(/\*{6}\d{4}/)?.[0];
  const inputRefs = useRef([]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const otpValue = otp.join("");
    if (otpValue.length === 6 && mobile.trim().length === 10) {
      VerifyAdharOtp(otpValue);
    } else {
      alert("Please enter a valid 4-digit OTP.");
    }
    if (mobile.trim().length === 10) {
      // SendMobileOtp(mobile);
    } else {
      // alert("Please enter a valid 10-digit mobile number.");
      setMsg("Please enter a valid 10-digit mobile number.");
    }
  };

  const handleInputChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const VerifyAdharOtp = async (otp) => {
    try {
      const body = {
        referenceId: uuidv4(),
        otpValue: otp,
        txnId: localStorage.getItem("txnId"),
        mobile: mobile,
      };
      const response = await VerifyAdharOTPServices({ body });
      if (response.status) {
        dispatch(setPatientDetails(response.result));
        SendMobileOtp(mobile);
      }
    } catch (error) {
      console.error("Error while getting token:", error);
    }
  };
  const SendMobileOtp = async (mobilenumber) => {
    try {
      localStorage.setItem("newmobilenumber", mobilenumber);
      const body = {
        mobileNumber: mobilenumber,
        txnId: localStorage.getItem("txnId"),
      };
      const response = await SendMobileOTPServices({ body });
      if (response.status) {
        setAdharOtp(true);
      }
    } catch (error) {
      console.error("Error while getting token:", error);
    }
  };

  useEffect(() => {
    let interval = null;
    if (timer > 0) {
      setCanResend(false);
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setCanResend(true);
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [timer]);
  const handleResendOtp = async () => {
    if (!canResend) return;
    await sendOtpFunction(); // Resend OTP
    setTimer(60); // Restart 60 seconds
  };

  return (
    <>
      <section className="container">
        <div className="abha-create-steps">
          <div className="row">
            <div className="col-md-6">
              <div className="create-abha">
                <h2>Create ABHA Number in 3 Steps</h2>
                <p>
                  Create ABHA Address and store all your medical records in one
                  place. Take part in the{" "}
                  <span className="highlight">
                    Ayushman Bharat Digital Mission (ABDM)
                  </span>{" "}
                  and get started on your digital health journey.
                </p>

                {/* Steps */}
                <div className="vertical-steps">
                  <div className="step-item">
                    <div className="step-marker">1</div>
                    <div className="step-content">
                      <h4>Verify Aadhaar Details</h4>
                      <p>
                        Enter your Aadhaar number and verify with OTP received
                        on Aadhaar linked mobile number.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">2</div>
                    <div className="step-content">
                      <h4>Link Mobile Number</h4>
                      <p>
                        Enter your mobile number and verify with OTP to link
                        with ABHA Address.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">3</div>
                    <div className="step-content">
                      <h4>Create ABHA</h4>
                      <p>Create your ABHA Number with a unique ABHA address.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Form Card */}
            <div className="col-md-6">
              <div className="form-card content">
                <h3>Verify Your Aadhaar</h3>
                <p className="pt-3">
                  Please Enter The 6-Digit OTP Sent To The Aadhaar-Linked Mobile
                  Number. We Have Sent The OTP To The Mobile Number Ending In
                  {maskedNumber}, Which Is Linked With The Aadhaar Number.
                </p>
                <form onSubmit={handleSubmit} className="pt-3">
                  <div className="col-ms-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
                    <div className="row">
                      <div className="col-ms-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
                        <input
                          type="text"
                          maxLength="10"
                          placeholder="Please Enter Mobile Number."
                          value={mobile}
                          onChange={(e) => setMobile(e.target.value)}
                          className="mobile-input mb-3"
                        />
                        {msg && (
                          <p
                            style={{
                              color: "#cf1f1f",
                            }}
                          >
                            {msg}
                          </p>
                        )}
                      </div>
                      {otp.map((digit, index) => (
                        <div
                          key={index}
                          className="col-ms-2 col-lg-2 col-xl-2 col-sm-2 col-xs-2"
                        >
                          <input
                            type="text"
                            maxLength="1"
                            placeholder="0"
                            value={digit}
                            // onChange={(e) => handleInputChange(e, index)}
                            ref={(el) => (inputRefs.current[index] = el)}
                            onChange={(e) => handleInputChange(e, index)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            className="mobile-input otp"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                  <button type="submit" className="continue-btn">
                    Continue
                  </button>
                  <p className="pt-2">
                    Don't Receive ОТР To Your Number ?{" "}
                    <a
                      className="resend-otp"
                      href="#"
                      onClick={handleResendOtp}
                      disabled={!canResend}
                      style={{ opacity: canResend ? 1 : 0.5 }}
                    >
                      {canResend ? "Resend OTP" : `Resend in ${timer}s`}
                    </a>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AdhaOtp;
